angular.module('impactx.controlChip').directive('appControlChip', ['$timeout', function ($timeout) {
    return {
        scope: {
            control: "=",
            allowed: "=",
            label: "=",
            maxNumber: "@",
            showMust: "=",
            requiredLabel: "=",
            readOnly: "=",
            name: "=",
            dialogData: "=",
            canCreate: "=",
            trns: "=",
            saveBasketFunction: "=",
            invalidFactorsLabel: "=",
            isAsync: "@?",
            entryPoint: "@?",
            fixedParamsFunc: "&?",
            type: "@?",
            helperDialogParams: "<",
            fractionSize: "=?",
            onAddFunc: "&",
            errorLabel: "@?", // custom label for error tooltip in validation button
            directSplitting: "=?",
            directSplitMaxValue: "=?",
            markDialogChangedFunc: "&?"
        },
        restrict: 'E',
        controller: 'ControlChipCtrl',
        templateUrl: 'shared/control/templates/controlchip.html',
        transclude: true,
        link: function (scope, element, attrs, ctrl) {
            scope.materialDesignInitForInputsDone = false;
            let materialDesignInitWatcher = scope.$watch(function () {
                if (scope.readOnly || scope.maxNumber == 1) {
                    return true;
                }
                let initDone = false;
                let inputElements = element.find('input');
                //we use tabindex, because this attribute is set in angular material after attaching the stuff to the correct input
                return inputElements.length > 0 && inputElements.attr('tabindex') && inputElements.attr('tabindex').length > 0
            },
            function (newValue) {
                if (newValue) {
                    scope.materialDesignInitForInputsDone = true;
                    if (materialDesignInitWatcher) {
                        materialDesignInitWatcher();
                    }
                    if (materialDesignInitWatcherBackup) {
                        $timeout.cancel(materialDesignInitWatcherBackup);
                    }
                }
            });
            let materialDesignInitWatcherBackup = $timeout(function() {
                //this is used as a backup mechanism. If the materialDesignInitForInputsDone watcher does not recognize the init.
                //The init should be done after 1 second...
                scope.materialDesignInitForInputsDone = true;
                if (materialDesignInitWatcher) {
                    materialDesignInitWatcher();
                }
            }, 1000);
        }
    };
}]);